import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getCurrentTenantId } from './tenantStore';

const LEAGUE_STORAGE_NAME = getCurrentTenantId() === 'tslh' ? 'league-storage-tslh' : 'league-storage';

interface LeagueState {
  selectedLeague: {
    id: number;
    name: string;
  } | null;
  setSelectedLeague: (league: { id: number; name: string; } | null) => void;
}

export const useLeagueStore = create<LeagueState>()(
  persist(
    (set) => ({
      selectedLeague: null,
      setSelectedLeague: (league) => set({ selectedLeague: league }),
    }),
    {
      name: LEAGUE_STORAGE_NAME,
    }
  )
);